import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {Button, ButtonLabel} from './ButtonElement';
import './Menu.css';

function Menu() {
  const [hover, setHover] = useState(false);
  const onHover = () => setHover(!hover);

  return (
    <div className="menu-container">
  <Navbar
  expand="md"
  sticky="top"
  collapseOnSelect
  className="menu-navbar animated-navbar"
>

        <Navbar.Brand as={Link} to="/">
          <img
            src="/images/logo1.png"
            alt="Hispanic Women's Association of SA"
            className='brand-logo'
            loading="lazy"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="menu-nav" />
        <Navbar.Collapse id="menu-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/">Inicio</Nav.Link>
            <Nav.Link as={Link} to="/quiénes somos">Quiénes Somos</Nav.Link>
            <Nav.Link as={Link} to="/áreas de enfoque">Áreas de Enfoque</Nav.Link>
            <Nav.Link as={Link} to="/boletin">Boletín Informativo</Nav.Link>

            <NavDropdown title="Programas" id="programas-dropdown">
              <NavDropdown.Item as={Link} to="/programas-la-familia">La Familia Hispana</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programas-disfruta-en-línea">Disfruta en Línea</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programas-orientación-información">Orientación e Información</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programas-oportunidades-laborales">Oportunidades Laborales en SA</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Únete a HWASA" id="unete-dropdown">
              <NavDropdown.Item as={Link} to="/unete-a-hwasa-socia">Socia</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/unete-a-hwasa-voluntaria">Voluntaria</NavDropdown.Item>
            </NavDropdown>
 <Button  
   className='btns'
   onMouseEnter={onHover}
         onMouseLeave={onHover}
           primary='true'
           dark='true'>
            <Link to='/contáctanos'> <ButtonLabel>Contáctanos</ButtonLabel></Link>                      
</Button>

<div id="google_translate_element" className="translate-widget"></div>
            
            
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

export default Menu;